// extracted by mini-css-extract-plugin
module.exports = {"information":"styles_information__1JtFD","informationIcon":"styles_informationIcon__2GKRR","informationTooltip":"styles_informationTooltip__3Pk6F"};